import { render, staticRenderFns } from "./SearchSuggestItem.vue?vue&type=template&id=0357f23f&scoped=true"
import script from "./SearchSuggestItem.vue?vue&type=script&lang=js"
export * from "./SearchSuggestItem.vue?vue&type=script&lang=js"
import style0 from "./SearchSuggestItem.vue?vue&type=style&index=0&id=0357f23f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0357f23f",
  null
  
)

export default component.exports